module.exports = __webpack_public_path__ + "media/giftcards/GC-Include-3-14620d64.svg";